import { normalize } from "normalizr";
import { camelizeKeys } from "humps";

import schemas from "../../../../utils/schemas";
import OfferApi from "api/offer/offerApi";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "../../../../actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { getResponsibleChangeOffers } from "./selectors";

export const loadOffersKey = (filters, pageSize) => {
  return JSON.stringify({ ...filters, pageSize });
};

export function loadResponsibleChangeOffers(filters, page, pageSize) {
  return async (dispatch, getState) => {
    const { loading, loaded } = getResponsibleChangeOffers(filters, page, pageSize, getState());
    let shouldCallApi = !loaded && !loading;
    if (!shouldCallApi) {
      return;
    }

    const key = loadOffersKey(filters, pageSize);
    dispatch({ type: actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_STARTED, key, page, pageSize });

    try {
      const response = await dispatch(sendHttpRequest(OfferApi.getResponsibleChangeOffers(filters, page, pageSize)));
      const camelizedJson = camelizeKeys(response.values);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.responsibleChangeOffers));

      dispatch({
        type: actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_SUCCEEDED,
        key,
        page,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_RESPONSIBLE_CHANGE_OFFERS_FAILED, key, page, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function bulkResponsibleChangeOffers(responsibleId, responsibleName, responsibleChangeOffers) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_RESPONSIBLE_OFFERS_STARTED,
      payload: responsibleChangeOffers,
      responsibleId: responsibleId
    });
    let event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        OfferApi.saveResponsibleToOffers(responsibleId, responsibleName, responsibleChangeOffers),
        "updateOfferResponsible",
        [eventTypes.OFFERS_RESPONSIBLE_UPDATED]
      )
    );
    if (event.ok) {
      dispatch({
        type: actionTypes.UPDATE_RESPONSIBLE_OFFERS_SUCCEEDED,
        payload: responsibleChangeOffers,
        responsibleId
      });
    } else {
      dispatch({
        type: actionTypes.UPDATE_RESPONSIBLE_OFFERS_FAILED,
        payload: { responsibleChangeOffers, error: event }
      });
    }
  };
}

export function refreshResponsibleOffers(filters, pageSize) {
  return dispatch => {
    const key = loadOffersKey(filters, pageSize);
    dispatch({ type: actionTypes.REFRESH_RESPONSIBLE_OFFERS, key });
  };
}
